(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mgp-malice-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mgp-malice-addon')) {
    customElements.define('mgp-malice-addon', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.closest('form');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.config = JSON.parse(this.querySelector('.mgp-malice__config').textContent);
        this.status = this.querySelector('.mgp-malice__status');
        this.summary = this.querySelector('.mgp-malice__summary');
        this.expressFields = this.querySelector('.mgp-malice__express-fields');
        this.blockedPayments = new Set();
        const indices = [...this.form.querySelectorAll('[name^="shopify-additional-items["]')].map(input => Number(input.name.match(/^shopify-additional-items\[(\d+)\]/)?.[1]) || 0);
        this.expressIndex = Math.max(0, ...indices) + 1;
        this.fresh = false;
        this.busy = false;
        this.variants = this.config.variants;
        const options = { signal: this.controller.signal };
        this.form.addEventListener('variant:changed', () => { this.checkbox.checked = false; this.render(); this.refresh(); }, options);
        this.form.addEventListener('change', () => this.render(), options);
        this.form.addEventListener('input', event => { if (event.target.name === 'quantity') this.render(); }, options);
        this.checkbox.addEventListener('change', () => { if (this.checkbox.checked) this.refresh(); }, options);
        this.form.addEventListener('click', event => {
          if (event.target.closest('.shopify-payment-button')) return;
          const button = event.target.closest('button[type="submit"]');
          if (button && (this.checkbox.checked || this.busy)) this.intercept(event, button);
        }, { ...options, capture: true });
        this.form.addEventListener('submit', event => {
          if (event.submitter?.closest('.shopify-payment-button')) return;
          if (this.checkbox.checked || this.busy) this.intercept(event, event.submitter || this.form.querySelector('button[type="submit"]'));
        }, { ...options, capture: true });
        window.addEventListener('focus', () => this.refresh(), options);
        document.addEventListener('cart:refresh', () => { if (!this.busy) this.refresh(); }, options);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, options);
        this.render();
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.expressFields?.replaceChildren();
        this.blockedPayments?.forEach(payment => { payment.inert = false; payment.removeAttribute('data-malice-pending'); });
      }
      selection() {
        const size = this.config.sizes[this.form.querySelector('[name="id"]')?.value];
        return this.variants.find(v => v.option1 === size);
      }
      quantity() { return Math.max(1, Math.floor(Number(this.form.querySelector('[name="quantity"]')?.value) || 1)); }
      packs() { return Math.ceil(Number(this.dataset.clips) * this.quantity() / 2); }
      canAdd(variant = this.selection()) { return Boolean(this.fresh && variant?.available && Number(variant.remaining) >= this.packs()); }
      money(cents) { return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
      template(text, values) { return text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match); }
      syncExpress() {
        this.expressFields.replaceChildren();
        if (this.checkbox.checked && this.canAdd() && !this.busy) {
          for (const [key, value] of Object.entries({ id: this.selection().id, quantity: this.packs() })) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `shopify-additional-items[${this.expressIndex}][${key}]`;
            input.value = String(value);
            this.expressFields.append(input);
          }
        }
        const blocked = this.busy || (this.checkbox.checked && !this.canAdd());
        for (const payment of this.form.querySelectorAll('.shopify-payment-button')) {
          if (blocked && !payment.inert) {
            payment.inert = true;
            payment.setAttribute('data-malice-pending', '');
            this.blockedPayments.add(payment);
          } else if (!blocked && this.blockedPayments.has(payment)) {
            payment.inert = false;
            payment.removeAttribute('data-malice-pending');
            this.blockedPayments.delete(payment);
          }
        }
      }
      render() {
        const variant = this.selection();
        this.hidden = !variant;
        if (!variant) { this.checkbox.checked = false; this.syncExpress(); return; }
        const available = this.canAdd(variant);
        this.checkbox.disabled = !available || this.busy;
        this.dataset.unavailable = String(!available);
        if (!available && this.fresh) this.checkbox.checked = false;
        const packs = this.packs();
        const values = { packs, size: variant.option1 === 'Long' ? this.dataset.long : this.dataset.short, price: this.money(variant.price * packs) };
        this.summary.textContent = this.template(this.dataset.packLabel, values);
        this.syncExpress();
        if (!this.busy) this.status.textContent = !this.fresh ? this.dataset.checking : (!variant.available ? this.dataset.stock : (!available ? this.dataset.insufficient : ''));
      }
      async refresh(force = false) {
        if (this.refreshing) {
          if (!force) return this.refreshing;
          await this.refreshing;
        }
        this.fresh = false;
        this.render();
        this.refreshing = (async () => {
          try {
            const response = await fetch(`${this.dataset.productUrl}?section_id=mgp-malice-stock&_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
            if (!response.ok) throw new Error('Product availability unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = JSON.parse(html.querySelector('[data-malice-stock]')?.textContent || 'null');
            if (!data || String(data.productId) !== this.dataset.productId || !Array.isArray(data.variants) || !data.variants.length) throw new Error('Invalid availability data');
            this.variants = data.variants;
            this.fresh = true;
            this.render();
            return this.selection();
          } catch (error) {
            this.fresh = false;
            this.checkbox.checked = false;
            this.render();
            this.status.textContent = this.dataset.error;
            return null;
          } finally { this.refreshing = null; }
        })();
        return this.refreshing;
      }
      async intercept(event, button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || !this.form.reportValidity() || !button || button.disabled) return;
        this.busy = true;
        const initialId = this.form.querySelector('[name="id"]').value;
        button.disabled = true;
        this.checkbox.disabled = true;
        this.status.textContent = this.dataset.checking;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        let success = false;
        try {
          const variant = await this.refresh(true);
          if (!this.canAdd(variant) || this.form.querySelector('[name="id"]').value !== initialId || !this.checkbox.checked) throw new Error(variant?.available ? this.dataset.insufficient : this.dataset.stock);
          const formData = new FormData(this.form);
          const main = { id: initialId, quantity: this.quantity(), properties: {} };
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') main.properties[match[1]] = value;
          }
          if (formData.get('selling_plan')) main.selling_plan = formData.get('selling_plan');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [main, { id: variant.id, quantity: this.packs() }] }) });
          const result = await response.json();
          if (!response.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          success = true;
          variant.remaining = Math.max(0, variant.remaining - this.packs());
          button.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button, variant: null, quantity: main.quantity, productAdded: true } }));
          if (window.theme?.pageType === 'cart' || window.theme?.cartType === 'page') window.location.href = window.routes?.cartUrl || `${root}cart`;
          if (window.theme?.cartType === 'drawer') document.dispatchEvent(new CustomEvent('modal:close'));
          this.status.textContent = this.dataset.added;
        } catch (error) {
          this.status.textContent = [this.dataset.stock, this.dataset.insufficient].includes(error.message) ? error.message : this.dataset.error;
        } finally {
          this.busy = false;
          if (button.isConnected && this.form.querySelector('[name="id"]').value === initialId) button.disabled = false;
          this.checkbox.disabled = !this.canAdd();
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (success) this.checkbox.checked = false;
          this.syncExpress();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgp-size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sizeChartOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }
    if (event.target.matches('dialog.mgp-size-chart-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
